import styled from "styled-components";

export const StyledLoader = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
`;
